// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { useAppDispatch, useAppSelector } from "app/hooks";
import icon_gift from "assets/images/svg/icon_gift.svg";
import Button from "components/Common/Button";
import ModalGift from "components/Common/Modal/ModalGift";
import { emptyTokenType } from "features/config/types";
import { connect as connectAction } from "features/wallet/connect";
import { WalletReducer } from "features/wallet/types";
import { selectWallet } from "features/wallet/walletReducer";
import React, { useState } from "react";

const Hero: React.FC<{ isStated: boolean }> = ({ isStated }) => {
  const [showModalGift, setShowModalGift] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const wallet = useAppSelector(selectWallet);

  const connect = async () => {
    await dispatch(connectAction(emptyTokenType));
  };
  function handleGetGift(): void {
    setShowModalGift((prev) => !prev);
  }

  return (
    <section
      className={`${isStated ? "pt-[140px]" : "pt-[90px]"} pb-[40px] md:pb-[60px] lg:pb-[70px] relative lg:h-[900px]`}
    >
      <div className="bg-hero md:absolute mt-12 md:mt-auto h-[180px] md:h-full w-full max-w-[1440px]"></div>
      <section className="max-w-[1024px] mx-auto px-12 md:px-14 text-center md:text-left relative pt-[30px] lg:pt-[93px] pb-[115px] overflow-hidden">
        {/* <video autoPlay muted loop className="md:absolute top-0 -right-[200px] w-full -z-[1] bg-black max-h-[620px]">
        <source type="video/mp4" srcSet="/scale-1.mp4 1024w, /scale-2.mp4 620w" src="/bg.mp4" />
      </video> */}
        <div className="text-white mx-auto md:mx-0 max-w-[506px]">
          <h2 className="text-[57px] font-bold max-w-[506px] hero-head">Fewcha DAO Rings Collection</h2>
          <div className="text-[18px] mt-6 max-w-[459px] font-light">
            Become an Early Backer and own limited Fewcha DAO Ring NFT with exclusive access & privileges in Fewcha
            ecosystem.
          </div>
          <div className="mt-6">
            {!(wallet as WalletReducer).isConnected && (
              <Button size="large" loading={(wallet as WalletReducer).loading} onClick={connect}>
                Connect Wallet
              </Button>
            )}
          </div>
        </div>
        <div className="fewcha--gift" onClick={handleGetGift}>
          <div className="content ">
            <div className="md:flex gap-x-4 items-center detail">
              <img src={icon_gift} alt="Gift" />
              <div className="hidden md:block font-bold leading-[140%] text-[16px]">
                <p className="text-highlight">Refer a friend &</p>
                <p className="text-white">Earn 2% rewards</p>
              </div>
            </div>
          </div>
        </div>
        {showModalGift && <ModalGift onControlModal={handleGetGift} />}
      </section>
    </section>
  );
};

export default Hero;
